import { render, staticRenderFns } from "./IconLastYearDate.vue?vue&type=template&id=62b553f2&"
import script from "./IconLastYearDate.vue?vue&type=script&lang=js&"
export * from "./IconLastYearDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b553f2')) {
      api.createRecord('62b553f2', component.options)
    } else {
      api.reload('62b553f2', component.options)
    }
    module.hot.accept("./IconLastYearDate.vue?vue&type=template&id=62b553f2&", function () {
      api.rerender('62b553f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconLastYearDate.vue"
export default component.exports